module.exports = "//cdn.mxpnl.com/static/asset-cache/eab8be4d0a768230812f30c56d871b2d/iron/common/assets/images/customer-logos/ancestry-logo.png";